window.addEventListener('DOMContentLoaded', () => {
  const elements = document.querySelectorAll('section.PromoBar p.PromoBar-item');

  if (!elements.length) {
    return;
  }

  elements.forEach(element => {
    const highlightWords = element?.dataset.highlightswords ?? '';
    
    if (!highlightWords) {
      return;
    }

    const highlightColor = element?.dataset.highlightcolor || 'blue';

    // Function to replace &amp; with &
    function replaceAmpersand(text) {
      return text.replace(/&amp;/g, '&');
    }

    // Replace &amp; with & in the element's innerHTML
    element.innerHTML = replaceAmpersand(element.innerHTML);

    const regex = new RegExp(`(${highlightWords.split(',').map(word => word.trim().replace(/[.*+?^%${}()|[\]\\]/g, '\\$&')).join('|')})`, 'gi');

    // Function to highlight text nodes
    function highlightTextNodes(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        const span = document.createElement('span');
        span.innerHTML = node.nodeValue.replace(regex, (match) => `<span style="color: ${highlightColor};">${match}</span>`);
        node.replaceWith(...span.childNodes);
      } else {
        node.childNodes.forEach(highlightTextNodes);
      }
    }

    // Highlight text nodes within the element
    element.childNodes.forEach(highlightTextNodes);
  });
});
